import CloseIcon from '@mui/icons-material/Close';
import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormLabel,
    Grid,
    IconButton,
    Stack,
    Table, TableBody,
    TableCell, TableContainer, TableHead, TableRow,
    Typography
} from '@mui/material';
import { useState } from 'react';
import { getFormatedDate, maskCardNumber } from '../../utils/common';
import { FORM_INPUTFIELD_STYLES, TABLE_BODY_ROW_MUI_STYLES, TABLE_HEADER_ROW_MUI_STYLES } from '../../utils/constant';
import edit from '../../assets/images/icons/edit2.svg'
import NormalInput from '../inputs/normalInput';
import { validationSchemaForKycUser } from '../../utils/schema';
import { Form, Formik } from 'formik';
import { useSelector } from 'react-redux';
import rotateImageIcon from '../../assets/images/icons/rotateImage.svg'
export default function UserProfileDialog({ open, handleClose, data, handleApproveKycHistory, handleUpdateUserInfo }) {
    const [modelOpen, setModelOpen] = useState(false);
    const [history, setHistory] = useState({ name: "", data: [] })
    const [imgapreview, setImg] = useState({ image: "", status: false });
    const [selectedKycHistoryId, setSelectedKycHistoryId] = useState(null);
    const [showEditUserInfoModal, setShowEditUserInfoModal] = useState(false);
    const [imageRotation,setImageRotation] = useState(0)
      const { userInfo } = useSelector((state) => state.commonSlice);
    function convertToInputDateFormat(dateStr) {
        if (!dateStr) return '';
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            return dateStr;
        }
        const parts = dateStr.split(/[-/]/);
        if (parts.length === 3) {
            let [day, month, year] = parts;
            if (year.length === 4) {
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        }
        return '';
    }
    const initialValuesForKycUserForm = {
        name: data?.name,
        dob: data?.dob,
        address: data?.address,
        city: data?.city,
        state: data?.state,
    };
    return (
        <>
            <Dialog
                onClose={handleClose}
                aria-labelledby="custom-dialog-title"
                open={open}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" className="capitalize-first-letter">
                            {data?.name} &emsp;
                            <button className={data.status?.toLowerCase() + " capitalize-first-letter"}>{data.status}</button>
                        </Typography>
                        <Grid item>
                            {userInfo?.id === 1 && <Button onClick={() => setShowEditUserInfoModal(true)} sx={{ marginRight: '25px', padding: 0, paddingBottom: '10px', filter: 'grayscale(50%) brightness(50%)', width: 'fit-content', minWidth: 'fit-content', }}>
                                <img src={edit} alt="edit" style={{ filter: 'grayscale(50%) brightness(50%)' }} />
                            </Button>}
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: '#000',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }} dividers>
                    <Grid container spacing={2} p={2}>
                        <Grid item md={3} lg={3} sm={12} xs={12}>
                            <Avatar
                                alt={data?.name}
                                src={data?.selfie}
                                sx={{ width: 100, height: 100, borderRadius: 2 }}
                            />
                        </Grid>
                        <Grid item md={9} lg={9} sm={12} xs={12} >
                            <Grid container spacing={1} >
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Typography variant="body1">Full Name:</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={9} lg={9}>
                                    <Typography variant="body1" className="capitalize-first-letter"><b>{data?.name}</b></Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Typography variant="body1">Date of Birth:</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={9} lg={9}>
                                    <Typography variant="body1" ><b>{data.dob || "N/A"}</b></Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={3} lg={3}>
                                    <Typography variant="body1">Address:</Typography>
                                </Grid>
                                <Grid item xs={12} sm={12} md={9} lg={9}>
                                    <Typography variant="body1">
                                        <b>{data.address + " " + data.city + " " + data.state}</b>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Table sx={{ mt: 2 }}>
                        <TableHead>
                            <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                                <TableCell align="left">Items</TableCell>
                                <TableCell align="left">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody >
                            <TableRow sx={TABLE_BODY_ROW_MUI_STYLES}>
                                <TableCell>PAN ({maskCardNumber(data.panNumber)})</TableCell>
                                <TableCell>
                                    <span className="viewIcon" onClick={() => {
                                        setModelOpen(true);
                                        setHistory({ name: "PAN History", data: data?.files?.find((v) => v.docType === "PAN") })
                                    }}>View History</span>
                                </TableCell>
                            </TableRow>
                            <TableRow sx={TABLE_BODY_ROW_MUI_STYLES}>
                                <TableCell>Aadhaar ({maskCardNumber(data.aadharNumber)})</TableCell>
                                <TableCell>
                                    <span className="viewIcon" onClick={() => {
                                        setModelOpen(true);
                                        setHistory({ name: "Aadhaar History", data: data?.files?.find((v) => v.docType === "AADHAR") })
                                    }}>View History</span>
                                </TableCell>
                            </TableRow>
                            <TableRow sx={TABLE_BODY_ROW_MUI_STYLES}>
                                <TableCell>Selfie</TableCell>
                                <TableCell >
                                    <span className="viewIcon" onClick={() => {
                                        setModelOpen(true);
                                        setHistory({ name: "Selfie History", data: data?.files?.find((v) => v.docType === "SELFIE") })
                                    }} >View History</span>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant='contained' sx={{ bgcolor: "gray" }} >Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                onClose={() => setModelOpen(false)}
                aria-labelledby="custom-dialog-title"
                open={modelOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" className="capitalize-first-letter">
                            {history.name} &emsp;
                        </Typography>
                        <Grid item>
                            <IconButton
                                onClick={() => setModelOpen(false)}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: '#000',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent sx={{ p: 0 }} dividers>
                    <Details userInfo={userInfo} history={history.data} name={history.name} setImg={setImg} setSelectedKycHistoryId={setSelectedKycHistoryId} selectedKycHistoryId={selectedKycHistoryId} />
                </DialogContent>
                <DialogActions>
                    {userInfo?.id === 1 && <Button sx={{ background: !selectedKycHistoryId?.id ? 'var(--draft)' : 'var(--color-blue)', color: 'white',"&:hover":{background: !selectedKycHistoryId?.id ? 'var(--draft)' : 'var(--color-blue)'} }} disabled={!selectedKycHistoryId?.id} onClick={() => { handleApproveKycHistory({ docId: selectedKycHistoryId?.id, status: 'APPROVED', docType: selectedKycHistoryId?.docType, userId: data.userId }); setModelOpen(false) }}>Approve</Button>
                  }  <Button onClick={() => setModelOpen(false)} variant='contained' sx={{ bgcolor: "gray" }} >Cancel</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                onClose={() => setImg((prev) => ({ ...prev, status: false }))}
                aria-labelledby="custom-dialog-title"
                open={imgapreview.status}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle sx={{ m: 0, }}>
                    <Grid container justifyContent="space-between" alignItems="center">
                        <Typography variant="h6" className="capitalize-first-letter">
                            Image &emsp;
                        </Typography>
                        <Grid item>
                            <Button disableRipple sx={{ marginRight: '25px',height:'24px',width:'24px', padding: 0, paddingBottom: '8px', filter: 'grayscale(50%) brightness(50%)',  minWidth: 'fit-content', }} onClick={()=>setImageRotation(prev => (prev + 90) % 360)}><img src={rotateImageIcon} alt="rotateImageIcon" style={{height:'20px',width:'20px'}}/></Button>
                            <IconButton
                                onClick={() => setImg((prev) => ({ ...prev, status: false }))}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: '#000',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent
                    sx={{
                        p: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    dividers
                >
                    <Box
                        width="100%"
                        height="100%"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <img
                            src={imgapreview.image}
                            style={{
                                width: "auto",
                                height: "auto",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                                rotate:`${imageRotation}deg`
                            }}
                            alt="preview"
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setImg((prev) => ({ ...prev, status: false }))} variant='contained' sx={{ bgcolor: "gray" }} >Cancel</Button>
                </DialogActions>
            </Dialog>
            {/* user info */}
            <Dialog
                onClose={() => setShowEditUserInfoModal(false)}
                aria-labelledby="custom-dialog-title"
                open={showEditUserInfoModal}
                maxWidth="md"
                fullWidth
            >
                <Formik
                    initialValues={initialValuesForKycUserForm}
                    validationSchema={validationSchemaForKycUser}
                    onSubmit={(values) => {
                        handleUpdateUserInfo({ userId: data.userId, ...values });
                        setShowEditUserInfoModal(false);
                    }}
                >
                    {({ values, handleChange, handleBlur, touched, errors, isValid }) => (
                        <Form>
                            <DialogTitle sx={{ m: 0, }}>
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Typography variant="h6" className="">
                                        Edit User Details
                                    </Typography>
                                    <Grid item>
                                        <IconButton
                                            onClick={() => setShowEditUserInfoModal(false)}
                                            sx={{
                                                position: 'absolute',
                                                right: 8,
                                                top: 8,
                                                color: '#000',
                                            }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </DialogTitle>
                            <DialogContent sx={{ p: 0 }} dividers>
                                <Box sx={{ padding: '30px' }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                                                Name
                                            </FormLabel>
                                            <NormalInput
                                                name="name"
                                                isRequired={true}
                                                type="text"
                                                focused={false}
                                                style={FORM_INPUTFIELD_STYLES}
                                                label="Name"
                                                sizeval="medium"
                                                values={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.name) && Boolean(errors.name)}
                                                helperText={touched.name && errors.name}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                                                Date of Birth
                                            </FormLabel>
                                            { }
                                            <NormalInput
                                                name="dob"
                                                type="date"
                                                focused={false}
                                                isRequired={true}
                                                label=""
                                                sizeval="medium"
                                                values={
                                                    (values.dob?.includes('/') || values.dob?.includes('-'))
                                                        ? convertToInputDateFormat(values.dob)
                                                        : values.dob
                                                }
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.dob) && Boolean(errors.dob)}
                                                helperText={touched.dob && errors.dob}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                                                First Line Address
                                            </FormLabel>
                                            <NormalInput
                                                name="address"
                                                isRequired={true}
                                                type="text"
                                                focused={false}
                                                style={FORM_INPUTFIELD_STYLES}
                                                label="Address"
                                                sizeval="medium"
                                                values={values.address}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.address) && Boolean(errors.address)}
                                                helperText={touched.address && errors.address}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                                                City
                                            </FormLabel>
                                            <NormalInput
                                                name="city"
                                                isRequired={true}
                                                type="text"
                                                focused={false}
                                                style={FORM_INPUTFIELD_STYLES}
                                                label="City"
                                                sizeval="medium"
                                                values={values.city}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.city) && Boolean(errors.city)}
                                                helperText={touched.city && errors.city}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormLabel required sx={{ fontSize: '14px', fontWeight: 500, color: '#726C6C', paddingBottom: '5px' }}>
                                                State
                                            </FormLabel>
                                            <NormalInput
                                                name="state"
                                                isRequired={true}
                                                type="text"
                                                focused={false}
                                                style={FORM_INPUTFIELD_STYLES}
                                                label="State"
                                                sizeval="medium"
                                                values={values.state}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={Boolean(touched.state) && Boolean(errors.state)}
                                                helperText={touched.state && errors.state}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button disabled={!isValid} type="submit" sx={{ background: isValid ? 'var(--color-blue)' : 'var(--draft)', color: 'white', "&:hover": { background: isValid ? 'var(--color-blue)' : 'var(--draft)' } }}>Update</Button>
                                <Button onClick={() => setShowEditUserInfoModal(false)} variant='contained' sx={{ bgcolor: "gray" }} >Cancel</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
}
const Details = ({ history, name, setImg, setSelectedKycHistoryId, selectedKycHistoryId,userInfo }) => {
    const [showApprovingFn, setShowApprovingFn] = useState(history?.attempts?.some((item)=>item.status==='APPROVED'))
    return <TableContainer stickyHeader >
        <Table stickyHeader aria-label="simple table">
            { }
            <TableHead>
                <TableRow sx={TABLE_HEADER_ROW_MUI_STYLES}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">Reason</TableCell>
                    <TableCell align="left">Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {history?.attempts?.length > 0 ? history?.attempts?.map((v) => {
                    let img = v.document;
                    let img2 = null;
                    if (v.docType === "AADHAR") {
                        const image = JSON.parse(v.document) || [];
                        img = image.length > 0 ? image[0] : "/";
                        img2 = image.length > 0 ? image[1] : "/";
                    }
                    return <TableRow sx={TABLE_BODY_ROW_MUI_STYLES}>
                        <TableCell align="left" className="capitalize-first-letter">
                            <Stack direction="row" alignItems={"center"} gap={1}>
                                {userInfo?.id === 1 && !showApprovingFn && v.status === 'REJECTED' && <Checkbox checked={selectedKycHistoryId?.id === v?.id}
                                    onChange={(e) => setSelectedKycHistoryId(e.target.checked ? v : null)} />}
                                <Stack direction={"column"} gap={2}>
                                    <img src={img} onClick={() => setImg({ image: img, status: true })} alt={name} style={{ width: 100, height: 50, borderRadius: 2, cursor: "pointer" }} />
                                    {img2 && <img src={img2} onClick={() => setImg({ image: img2, status: true })} alt={name} style={{ width: 100, height: 50, borderRadius: 2, cursor: "pointer" }} />}
                                </Stack>
                            </Stack>
                        </TableCell>
                        <TableCell align="left" className="capitalize-first-letter">
                            {getFormatedDate(v.createdDate, "DD-MM-YYYY hh:mmA")}
                        </TableCell>
                        <TableCell align="left" >{v.reason} </TableCell>
                        <TableCell align="left"> <button className={v.status?.toLowerCase() + " capitalize-first-letter"}>{v.status}</button> </TableCell>
                    </TableRow>
                }) : <TableRow colSpan={5}>
                    <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                        <Typography
                            color="inherit"
                            variant="subtitle1"
                            alignItems={"center"}
                            component="h3"
                        >
                            No Data found!
                        </Typography>
                    </TableCell>
                </TableRow>}
            </TableBody>
        </Table>
    </TableContainer>
}